import { ReactComponent as OverViewIcon } from "../assests/OverViewIcon.svg";
import { ReactComponent as Dashboard } from "../assests/rm_dashboard.svg";

import { MY_PROFILE_PATH, PageConfig, PROJECTS } from "../configure/PathConfig";
import siteConfig from "../common/lang/locale/en-US";
import { formatString } from "../utils/dataformatter/Rawformatter";
import { CalendarFold, Globe, MailCheck, UserCog, FileText } from 'lucide-react';
import { IdCard } from 'lucide-react';
import { MessageSquareCode } from 'lucide-react';
import { LockKeyholeOpen } from 'lucide-react';
import { CircleDollarSign } from 'lucide-react';
import { BadgeCheck } from 'lucide-react';
import { FileCog } from 'lucide-react';
import { Rocket } from 'lucide-react';
import { FileSearch } from 'lucide-react';
import { Folder } from 'lucide-react';
import { NotebookPen } from 'lucide-react';
import { Users } from 'lucide-react';
import { User } from 'lucide-react';
import { ListChecks } from 'lucide-react';
import { Waypoints } from 'lucide-react';
import { LayoutGrid } from 'lucide-react';
import { CircleUserRound } from 'lucide-react';
import { ShieldCheck } from 'lucide-react';
import { ChartNetwork } from 'lucide-react';
import { BookCopy } from 'lucide-react';
import { UserPen } from 'lucide-react';
import { FileUser } from 'lucide-react';
import useIntl from "@common/lang/locale/en-US";


export const menuIcons = {
    "Overview": OverViewIcon,
    "Scoped Deals": FileCog,
    "INAB": Rocket,
    "Deal Review": FileSearch,
    "Legal Review": Folder,
    "Resource Management": Users,
    "Admin": UserCog,
    // Menu items without icons
    "Dashboard": Dashboard ,
    "People": User ,
    "Profile": CircleUserRound ,
    "RM Sheet": ShieldCheck,
    "Projects": ListChecks ,
    "Resource Allocation": LayoutGrid ,
    "Resource Request": Waypoints ,
    "User Management": IdCard ,
    "Notification": MessageSquareCode,
    "Access Policy": LockKeyholeOpen,
    "Rate Card": CircleDollarSign ,
    "Skills Certification" : BadgeCheck,
    "Playground" : NotebookPen, 
    "Bench Projection" : ChartNetwork,
    "Reports" : BookCopy,
    "RM-Reports" : FileText,
    "My Profile" : UserPen,
    "Demand Pipeline" : FileUser,
    "Global Availability" : Globe,
    "YTD Summary Report" : CalendarFold,
    "Feedback" : MailCheck
};



const url = window.location.pathname;

export const menus = [
        // {
        //     id: 100,
        //     icon: <OverViewIcon />,
        //     actualPath:`${PageConfig.DASHBOARD}`,
        //     title: "Overview",
        //     to: `${PageConfig.DASHBOARD}/${formatString(siteConfig["tab.scopedprojects"])}`,
        //     items: [],
        //     requiredPermissions:[ "overview_view"],
        //     active: true,
        // },
        // {
        //     id: 101,
        //     // icon: <Crosshair />,
        //     actualPath:`${PageConfig["PRELIMINARY"].DASHBOARD}`,
        //     title: "Scoped Deals",
        //     to: `${PageConfig["PRELIMINARY"].DASHBOARD}/new`,
        //     items: [],
        //     requiredPermissions: ["scopeddeals_view"],
        //     active: true,
        // },
        {
            id: 102,
            // icon: <INABIcon />,
            actualPath:`${PageConfig["INAB"].DASHBOARD}`,
            title: "INAB",
            to: `${PageConfig["INAB"].DASHBOARD}/${formatString(siteConfig["INAB.tab.new"])}`,
            items: [],
            requiredPermissions: ["inab_view"],
            active: true,
        },
        {
            id: 200,
            // icon: <DealReviewIcon />,
            actualPath: `${PageConfig["DEALS"].DEALREVIEWDASHBOARD}`,
            title: "Deal Review",
            to: `${PageConfig["DEALS"].DEALREVIEWDASHBOARD}/${formatString(siteConfig["tab.new"])}`,
            items: [],
            active: true,
            // items: [
            // 	{
            // 		id: 201,
            // 		title: "Dashboard",
            // 		to: `${PageConfig["DEALS"].DEALREVIEWDASHBOARD}/0`,
            // 		active: false,
            // 	},
            // ],
            requiredPermissions: ["dealreview_view"]
        },
        {
            id: 300,
            // icon: <LegalReviewIcon />,
            actualPath: `${PageConfig["LEGAL"].LEGAL_DASHBOARD}`,
            title: "Legal Review",
            to: `${PageConfig["LEGAL"].LEGAL_DASHBOARD}/${formatString(siteConfig["tab.new"])}`,
            active: true,
            items: [],
            // items: [
            // 	{
            // 		id: 301,
            // 		title: "Dashboard",
            // 		to: `${PageConfig["LEGAL"].LEGAL_DASHBOARD}/0`,
            // 		active: false,
            // 	},
            // ],
            requiredPermissions: ["legalreview_view"]
        },
        // {
        //     id: 600,
        //     title: "Profile",
        //     actualPath: `${PageConfig["PROFILE"].MYPROFILE}`,
        //     icon: <People />,
        //     to: `${PageConfig["PROFILE"].MYPROFILE}/${localStorage.getItem('employeeId')}`,
        //     active: true,
        //     requiredPermissions: ["rm_employee_profile_view"]
        // },
           {
            id: 600,
            title: "Playground",
            actualPath: `${PageConfig["PLAYGROUND"].PLAYGROUND}`,
            // icon: <People />,
            to: `${PageConfig["PLAYGROUND"].PROJECTS}`,
            active: true,
            requiredPermissions: ["playground_view_edit"]
        },
        {
            id: 404,
            // icon:<Project />,
            actualPath: `${PROJECTS}`,
            title: "Projects",
            to: `${PROJECTS}/${formatString(siteConfig["rm.project.pendingprojects"])}`,
            active: true,
            requiredPermissions: ["rm_project_view"]
        },
    {
        id: 800,
        title: "People",
        actualPath: `${PageConfig["RM"].PEOPLELANDING}`,
        // icon:<People />,
        to: `${PageConfig["RM"].PEOPLELANDING}/all_resources`,
        active: true,
        requiredPermissions: ["people_list_view", "rm_employee_profile_view"]
    },
        {
        id: 407,
        // icon: <RMIcon />,
        title: "Reports",
        to: `${PageConfig["RG"].RGBench}/global_forecasting`,
        actualPath: '/reports',
        active: false,
        items: [
            {
                id: 413,
                title: "RM-Reports",
                to: `${PageConfig["RG"].RGBench}/global_forecasting`,
                actualPath: '/reports',
                active: false,
                items: [
                    {
                        id: 408,
                        title: "Bench Projection",
                        actualPath: `${PageConfig["RG"].RGBench}`,
                        to: `${PageConfig["RG"].RGBench}/global_forecasting`,
                        active: true,
                        requiredPermissions: ["report_generation_view", "report_generation_edit"]
                    },
                    {
                        id: 411,
                        actualPath: `${PageConfig["RG"].RGGlobalAvailability}`,
                        title: "Global Availability",
                        to: `${PageConfig["RG"].RGGlobalAvailability}/executivesummary`,
                        active: true,
                        requiredPermissions: ["report_generation_view", "report_generation_edit"]
                    },
                    {
                        id: 412,
                        actualPath: `${PageConfig["RG"].RGGlobalAvailabilityYTDSummaryReport}`,
                        title: "YTD Summary Report",
                        to: `${PageConfig["RG"].RGGlobalAvailabilityYTDSummaryReport}`,
                        active: true,
                        requiredPermissions: ["report_generation_view", "report_generation_edit"]
                    }
                ],
                requiredPermissions: ["report_generation_view"]
            }
        ],
        requiredPermissions: ["report_generation_view"]
    },
        {
            id: 400,
            // icon: <RMIcon />,
            title: "Resource Management",
            to: ``,
            actualPath:'/rm',
            active: false,
            items: [
                // {
                //     id: 401,
                //     icon:<Dashboard />,
                //     actualPath: `${PageConfig["RM"].RMDASHBOARD}`,
                //     title: "Dashboard",
                //     to: `${PageConfig["RM"].RMDASHBOARD}`,
                //     active: true,
                //     requiredPermissions:[ "rm_dashboard_view"]
                // },
                // {
                //     id: 402,
                //     title: "People",
                //     actualPath: `${PageConfig["RM"].PEOPLELANDING}`,
                //     // icon:<People />,
                //     to: `${PageConfig["RM"].PEOPLELANDING}/all_resources`,
                //     active: true,
                //     requiredPermissions: ["rm_people_list_view","rm_employee_profile_view"]
                // },
                // {
                //     id: 407,
                //     // icon:<Project />,
                //     actualPath: `${PageConfig["RM"].RMLANDING}`,
                //     title: "RM Sheet",
                //     to: `${PageConfig["RM"].RMLANDING}/${formatString(siteConfig["rm.rmsheet.allrmsheet"])}`,
                //     active: true,
                //     requiredPermissions: ["rm_people_list_view","rm_employee_profile_view"]

                // },
                {
                    id: 405,
                    // icon: <DemandPipeline />,
                    actualPath: `${PageConfig["RM"].DEMANDPIPELINE}`,
                    title: "Resource Request",
                    to: `${PageConfig["RM"].DEMANDPIPELINE}/${formatString(useIntl["rm.demandpipeline.project"])}`,
                    active: true,
                    requiredPermissions: ["rm_resource_request_view"]
                },
                {
                    id: 406,
                    // icon: <ResourceAllocation />,
                    actualPath: `${PageConfig["RM"].PROJECTHOME}`,
                    title: "Resource Allocation",
                    to: `${PageConfig["RM"].PROJECTHOME}/${formatString(siteConfig["rm.resourceallocation.new"])}`,
                    active: true,
                    requiredPermissions:[ "rm_resource_allocation_view"]
                },
                {
                    id: 409,
                    // icon:<Project />,
                    actualPath: `${PageConfig["RG"].RGRMSheet}`,
                    title: "RM Sheet",
                    to: `${PageConfig["RG"].RGRMSheet}`,
                    active: true,
                    requiredPermissions: ["rm_rmsheet_view","rm_employee_profile_view"]
                },
                {
                    id: 410,
                    // icon:<Project />,
                    actualPath: `${PageConfig["RG"].RGDemandResources}`,
                    title: "Demand Pipeline",
                    to: `${PageConfig["RG"].RGDemandResources}`,
                    active: true,
                    requiredPermissions: ["rm_demand_pipeline_view"]

                },
            ],
            requiredPermissions: ["resourcemanagement_menu"]
        },
		{
			id: 500,
			// icon: <AdminIcon />,
			title: "Admin",
			to: ``,
            actualPath:'/admin',
			active: false,
			items: [
				{
					id: 501,
					title: "User Management",
                    actualPath: `${PageConfig["ADMIN"].DASHBOARD}`,
                    // icon : <AdminDB />,
					to: `${PageConfig["ADMIN"].DASHBOARD}/${formatString(siteConfig["tab.admin.users"])}`,
					active: true,
                    requiredPermissions: ["admin_usermanagement_view"]
				},
				{
					id: 502,
					title: "Notification",
                    actualPath: `${PageConfig["ADMIN"].NOTIFICATION}`,
                    // icon: <Notification />,
					to: `${PageConfig["ADMIN"].NOTIFICATION}`,
					active: url === `${PageConfig["ADMIN"].NOTIFICATION}`,
                    requiredPermissions:[ "notification_view"]
                },
				{
					id: 503,
					title: "Access Policy",
                    actualPath: `${PageConfig["ADMIN"].RBAC}`,
                    // icon: <AccessPolicy />,
					to: `${PageConfig["ADMIN"].RBAC}`,
					active: url === `${PageConfig["ADMIN"].RBAC}`,
                    requiredPermissions: ["admin_accesspolicy_view"]
                },
                {
					id: 504,
					title: "Rate Card",
                    actualPath: `${PageConfig["ADMIN"].RBACRATECARD}`,
                    // icon:<RateCard />,
					to: `${PageConfig["ADMIN"].RBACRATECARD}`,
					active: url === `${PageConfig["ADMIN"].RBACRATECARD}`,
                    requiredPermissions: ["admin_ratecard_view"]
                },
                 {
					id: 505,
					title: "Skills Certification",
                    actualPath: `${PageConfig["ADMIN"].SKILLSANDCERTIFICATION}`,
                    // icon:<RateCard />,
					to: `${PageConfig["ADMIN"].SKILLSANDCERTIFICATION}`,
					active: url === `${PageConfig["ADMIN"].SKILLSANDCERTIFICATION}`,
                    requiredPermissions: ["admin_skillscertification_view"]
                },
                {
                    id: 506,
                    title: "Feedback",
                    actualPath: `${PageConfig["ADMIN"].FEEDBACK}`,
                    // icon:<RateCard />,
                    to: `${PageConfig["ADMIN"].FEEDBACK}`,
                    active: url === `${PageConfig["ADMIN"].FEEDBACK}`,
                    requiredPermissions: ["admin_feedback_view"]
                },
			],
			requiredPermissions:[ "admin_menu"]
		},
        {
            id: 700,
            // icon:<Project />,
            actualPath: `${MY_PROFILE_PATH}`,
            title: "My Profile",
            to: `${MY_PROFILE_PATH}`,
            active: true,
            requiredPermissions: ["my_profile_view"]
        },

    ];
